module.exports = __webpack_public_path__ + "img/makerTml.4d2a4bc7.png";